import { Link, NavLink, Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { MessageCircle, Phone } from "lucide-react";
import { SITE as cfg } from "@/data/site";

const TITLES = {
  "/": "Top End Wheels — Darwin 4x4 & SUV Hire | Hilux & Kluger",
  "/vehicles/hilux": "Toyota Hilux SR 4x4 Hire Darwin — A$299/day | Top End Wheels",
  "/vehicles/kluger": "Toyota Kluger Hybrid 7-Seater Hire Darwin — A$199/day | Top End Wheels",
  "/where-to-go": "Where to go from Darwin — Litchfield, Kakadu & Adelaide River | Top End Wheels",
  "/enquiry": "Enquire & Book — Top End Wheels Darwin",
  "/faq": "FAQ — Bond, Excess, Kilometres | Top End Wheels",
  "/terms": "Rental Terms — Top End Wheels",
};

export default function Layout() {
  const { pathname } = useLocation();
  useEffect(() => {
    const path = pathname === "/" ? "/" : pathname.replace(/\/$/, "");
    document.querySelector('link[rel="canonical"]').href = `https://topendwheels.com${path === "/" ? "/" : path}`;
    document.title = TITLES[path] || TITLES["/"];
    window.scrollTo(0, 0);
  }, [pathname]);
  const wa = cfg.whatsapp ? `https://wa.me/${cfg.whatsapp}` : "#";
  return (
    <>
      <header className="sticky top-0 z-40 bg-[#F7F5F0]/85 backdrop-blur-xl border-b border-black/10">
        <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2.5" data-testid="nav-home">
            <img src="/logo-mark.svg" alt={cfg.brand} className="h-9 w-9" onError={(e) => { e.currentTarget.style.display = 'none'; }}/>
            <span className="font-black tracking-tight text-lg text-[#1C1C1C]">{cfg.brand}</span>
          </Link>
          <nav className="hidden md:flex items-center gap-8 text-sm font-medium text-[#1C1C1C]">
            <NavLink to="/vehicles/hilux" className="hover:text-[#BA5A3A]" data-testid="nav-hilux">Hilux</NavLink>
            <NavLink to="/vehicles/kluger" className="hover:text-[#BA5A3A]" data-testid="nav-kluger">Kluger</NavLink>
            <NavLink to="/where-to-go" className="hover:text-[#BA5A3A]" data-testid="nav-trips">Where to go</NavLink>
            <NavLink to="/enquiry" className="hover:text-[#BA5A3A]" data-testid="nav-enquiry">Enquiry</NavLink>
            <NavLink to="/faq" className="hover:text-[#BA5A3A]" data-testid="nav-faq">FAQ</NavLink>
            <NavLink to="/terms" className="hover:text-[#BA5A3A]" data-testid="nav-terms">Terms</NavLink>
          </nav>
          <a href={wa} target="_blank" rel="noreferrer" className="btn-ghost text-xs hidden sm:inline-flex" data-testid="nav-whatsapp">
            <MessageCircle className="w-4 h-4" /> WhatsApp
          </a>
        </div>
      </header>
      <main><Outlet /></main>
      <footer className="relative bg-[#1C1C1C] text-[#F7F5F0] mt-24 grain">
        <div className="max-w-7xl mx-auto px-6 py-16 grid md:grid-cols-4 gap-8 relative">
          <div>
            <div className="flex items-center gap-2.5">
              <img src="/logo-mark.svg" alt={cfg.brand} className="h-10 w-10"/>
              <span className="text-2xl font-black tracking-tight">{cfg.brand}</span>
            </div>
            <p className="text-sm text-white/60 mt-4">Independent Territory-based hire. Straight-talking terms.</p>
          </div>
          <div>
            <div className="overline text-white/60">Fleet</div>
            <ul className="mt-3 space-y-2 text-sm">
              <li><Link to="/vehicles/hilux" className="hover:text-[#BA5A3A]">Toyota Hilux SR 4x4</Link></li>
              <li><Link to="/vehicles/kluger" className="hover:text-[#BA5A3A]">Toyota Kluger Grande</Link></li>
            </ul>
          </div>
          <div>
            <div className="overline text-white/60">Help</div>
            <ul className="mt-3 space-y-2 text-sm">
              <li><Link to="/faq" className="hover:text-[#BA5A3A]">FAQ</Link></li>
              <li><Link to="/where-to-go" className="hover:text-[#BA5A3A]">Where to go</Link></li>
              <li><Link to="/terms" className="hover:text-[#BA5A3A]">Rental terms</Link></li>
              <li><Link to="/enquiry" className="hover:text-[#BA5A3A]">Long-term / interstate</Link></li>
            </ul>
          </div>
          <div>
            <div className="overline text-white/60">Contact</div>
            <ul className="mt-3 space-y-2 text-sm">
              <li className="flex items-center gap-2"><Phone className="w-4 h-4" /> {cfg.phone}</li>
              <li>{cfg.contact_email}</li>
            </ul>
          </div>
        </div>
        <div className="border-t border-white/10 py-4 text-center text-xs text-white/40">© {new Date().getFullYear()} {cfg.brand}. Darwin, NT.</div>
      </footer>
      {cfg.whatsapp && (
        <a href={wa} target="_blank" rel="noreferrer"
           className="fixed bottom-6 right-6 z-50 bg-[#25D366] text-white p-4 rounded-full shadow-lg hover:scale-110 transition"
           data-testid="floating-whatsapp">
          <MessageCircle className="w-6 h-6" />
        </a>
      )}
    </>
  );
}
